import React from 'react';
import COLORS from '../../../theme/colors';
import { Box, Grid, Card, CardMedia, CardContent, Button, Typography, CardActions } from '@mui/material';
import melbet from '../../images/melbet.png'
import xbet from '../../images/1xbet.webp'
import betwin from '../../images/betwin.png'
import win from '../../images/1win.jpg'
import linebet from '../../images/Linebet.jpg'
import bet from '../../images/bet.webp'
import starz from '../../images/starz.png'
import winwin from '../../images/winwin.png'
import goldpari from '../../images/goldpari.png'
import betpari from '../../images/betpari.png'
import betLyrics from '../../images/bet-Lyrics.webp'
import afropari from '../../images/afropari.png'

// Exemple d'images de partenaires (remplacez par les vôtres)
const partnerLogos = [
  { name: '1xbet', imgSrc: xbet, code: 'MHPRONO', lien: 'https://reffpa.com/L?tag=d_3780009m_97c_&site=3780009&ad=97' },
  { name: 'BetWinner', imgSrc: betwin, code: 'B2030', lien: 'https://bwredir.com/1GoB?p=%2Fregistration%2F' },
  { name: '888starz', imgSrc: starz, code: 'B2030', lien : ' https://chill2win.fun/L?tag=d_4290983m_63543c_&site=4290983&ad=63543' },
  { name: '1win', imgSrc: win, code: 'B2030', lien:'https://1wiqju.life/?open=register&p=wy8h' },
  { name: 'MelBet', imgSrc: melbet, code: 'B2030', lien:'https://refpa3665.com/L?tag=d_3780068m_66335c_&site=3780068&ad=66335' },
  { name: 'LineBet', imgSrc: linebet, code: 'B2030', lien : 'https://lb-aff.com/L?tag=d_2547201m_22611c_sait&site=2547201&ad=22611&r=registration/' },
   { name: 'Winwinbet', imgSrc: winwin, code: 'B2030', lien : 'https://refpa98980.com/L?tag=d_4320191m_94904c_&site=4320191&ad=94904' },
  { name: 'Goldpari', imgSrc: goldpari, code: 'B2030', lien : 'https://gpaff.top/L?tag=d_4293508m_69627c_&site=4293508&ad=69627' },
  { name: 'BetPari', imgSrc: betpari, code: 'B2030', lien : 'https://betpari-click.com/2obi?p=%2Fregistration%2F' },
  { name: 'AfroPari', imgSrc: afropari, code: 'B2030', lien : 'https://refpa84423.com/L?tag=d_5710922m_70055c_&site=5710922&ad=70055' },


  


];

const PartenaireBookSection = () => {
  return (
    <Box sx={{ padding: '50px 10%', backgroundColor: '#f8f9fa' }}>
        <Typography variant="subtitle1" align="center" sx={{ mb: 1, color:'#435666' }}>
        <img
              src={bet}
              alt="BET-Partners"
              //onClick={() => {navigate(`/`)}}
              width={50}
              height={50} />
        </Typography>

      {/* Titre de la section */}
      <Typography variant="h5" gutterBottom align="center" sx={{mb:5, fontWeight: 'bold' }}>
      Gagner 200% à 500% de bonus en vous inscrivant avec les codes promos certifiés suivants
      </Typography>
      
      {/* Grille des cartes de partenaires */}
      <Grid container spacing={4} justifyContent="center">
        {partnerLogos.map((partner, index) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
            <Card
            onClick={(e) => {
              window.open(`${partner.lien}`, '_blank');              
            }} 
            sx={{ 
              ':hover': { 
                boxShadow: 6, // Augmente l'ombre au survol pour un effet dynamique 
                transform: 'scale(1.05)' // Zoom léger au survol
              },
              backgroundColor:'#6589a8',
              transition: 'transform 0.3s ease-in-out' 
            }}>
              <CardMedia
                component="img"
                height="140"
                image={partner.imgSrc} // Image du partenaire
                alt={partner.name}
                loading="lazy"
                sx={{ padding: 2, objectFit: 'cover' }}
              />
              <CardContent>
                <Typography gutterBottom style={{fontSize:'15px', 
                  color:'white', fontWeight:'bold'}} component="div" align="center">
                Des offres de bienvenue abondantes               
                </Typography>                
              </CardContent>
              <CardActions >                
              <Button align="center" fullWidth style={{fontWeight:'bold',
              backgroundColor:'#435666',
                fontFamily:'', color:'white'}}>
                   Code Promo : {partner.code}
                </Button>
              </CardActions>   
              <CardActions >                
              <Button align="center" fullWidth style={{fontWeight:'bold',
              backgroundColor:COLORS.accent,
                fontFamily:'', color:'white'}}>
                   Recevoir un bonus
                </Button>
              </CardActions>              
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default PartenaireBookSection;
